export default __webpack_public_path__ + "static/media/dp.7f1c19ae.jpg";